function Badge({ children, toneClass = '', className = '' }) {
  return (
    <span className={`rounded border px-1.5 py-0.5 text-xs font-semibold ${toneClass} ${className}`}>
      {children}
    </span>
  );
}

export default Badge;
